export default __webpack_public_path__ + "c014ebd54225a155a9b86ec3bfed0a5d.svg";